import { makeStyles } from '@material-ui/core/styles';
import { rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

export const styles = makeStyles(() => ({
  centerPageContent: {
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    padding: '0 20px 0 20px',
    textAlign: 'center',
    height: vh(60),
  },
  manualEntryCenterPage: {
    overflow: 'auto',
    overflowWrap: 'anywhere',
    textAlign: 'center',
    height: '100%',
  },
  paymentTitleBar: {
    color: themeColor.infoMain,
    borderTop: '10px solid #264558',
    width: '4.85vw',
    margin: '3vh auto',
  },
  checkScreenMessageTitleGrid: {
    fontSize: vh(4.18),
    color: themeColor.modalTitle,
    fontWeight: 500,
  },
  pageContent: {
    zIndex: 1,
    paddingBottom: '1vh',
    justifyContent: 'center',
  },
  checkScreenMessageGridContainer: {
    width: 'inherit',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkScreenDividerGrid: {
    width: '100%',
  },
  checkScreenBottomButtons: {
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-end',
  },
  checkScreenMessageBodyGrid: {
    paddingBottom: '3vh',
  },
  containedButton: {
    marginRight: vw(1),
  },
  bottomButton: {
    width: vw(10),
  },
  dividerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3vh',
  },
  divider: {
    width: '150px',
  },
  dividerMiddle: {
    padding: '0 20px 0 20px',
  },
  greyColor: {
    color: themeColor.palesky,
  },
  manualEntryButtonContainers: {
    justifyContent: 'center',
    marginBottom: vh(1.5),
  },
  manualEndorseMessageGridContainer: {
    width: 'inherit',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backCheckTextBorder: {
    width: '4.85vw',
    height: '10vh',
    borderColor: themeColor.palesky,
    color: themeColor.infoMain,
  },
  backCheckText: {
    justifyContent: 'left',
  },
  boxContainer: {
    border: '1px solid',
    borderColor: themeColor.palesky,
    '@media (width: 1920px) and (height: 1080px)': {
      height: rem(18),
      width: rem(34),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      height: rem(18),
      width: rem(34),
    },
    '@media (width: 1024px) and (height: 576px)': {
      marginBottom: vh(2),
    },
  },
  box: {
    height: rem(9.5),
    width: rem(27.25),
    padding: rem(2),
    '@media (width: 1024px) and (height: 576px)': {
      height: rem(8.5),
      paddingTop: rem(1),
      paddingBottom: rem(0.5),
    },
  },
  textPositions: {
    textAlign: 'left',
    marginBottom: vh(0.5),
    '@media (width: 1024px) and (height: 576px)': {
      marginBottom: vh(0),
    },
  },
}));
